/* global document */
import '../../../styles/next/blocks/_feature-panels.scss';

// acf/next-feature-panels: the last panel hovered or focused becomes the default, so it stays open
// (with its image) after the pointer or focus leaves the row. The CSS opens .is-default and shows
// .is-rest only while nothing in the row is hovered or focused. Without JS the Twig default stays.
const initFeaturePanels = (wrapper) => {
  const panels = [...wrapper.querySelectorAll('.aqn-feature-panels__panel')];
  const backdrops = [...wrapper.querySelectorAll('.aqn-feature-panels__backdrop')];

  const remember = (index) => {
    panels.forEach((panel, i) => panel.classList.toggle('is-default', i === index));
    backdrops.forEach((backdrop, i) => backdrop.classList.toggle('is-rest', i === index));
  };

  panels.forEach((panel, index) => {
    panel.addEventListener('mouseenter', () => remember(index));
    panel.addEventListener('focusin', () => remember(index));
  });
};

const init = () => document.querySelectorAll('[data-feature-panels]').forEach(initFeaturePanels);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
